import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'


export const lighthouseDashboardApi = createApi({
    reducerPath: 'lighthouseDashboardApi',
    tagTypes: ["LighthouseConfig"],
    baseQuery: fetchBaseQuery({
        baseUrl: (process.env.REACT_APP_SERVER_PROXY||"http://localhost:3000")+"/api/dashboard/lighthouse/",
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('token')
            headers.set('Authorization', `JWT ${token}`)
            return headers
        }
    }),
    endpoints: (build) => ({
        getLighthouseDashboardConfig: build.query({
            query: () => `config`,
            providesTags: ["LighthouseConfig"]
        }),
        updateLighthouseDashboardConfig: build.mutation({
            query: (config) => ({
                url: 'config/update',
                method: 'POST',
                body: {config}
            }),
            invalidatesTags: ["LighthouseConfig"]
        })
    })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetLighthouseDashboardConfigQuery, useUpdateLighthouseDashboardConfigMutation } = lighthouseDashboardApi